<template>
  <div>
    <div id="dvApplicationPrint" style="-webkit-print-color-adjust:exact!important;color-adjust:exact!important;"
      :style=" {'background-image':'url('+dgwatermk+')no-repeat;'}">
      <img src="../assets/images/WaterMarkClient.png" id="imgWatMark" alt="" style="display:none; visibility:hidden;" />
      <div style="width: 6.25in; color: black; font-size: 8.5pt">
        <div style="height: 8.6in" class="page">
          <table style="width: 100%">
            <tr>
              <td></td>
            </tr>
          </table>

          <br />
            <table style="width: 100%;" >
            <tr>
              <td>
                <img
                  id="orgLogo1"
                  alt="AOCLOGO"
                  src="../assets/images/AOC_Logo.png"
                  style="height: 75px; width: 70px"
                />
              </td>
              <td align="center">
                <span
                  style="
                    text-decoration: underline;
                    font-weight: bold;
                    font-size: 14px;
                  "
                  >APPLICATION FORM FOR {{ lblAdvtNo }} :: ARMY ORDNANCE
                  CORPS</span
                >
              </td>
              <td>
                <img
                  id="orgLogo2"
                  alt="Satyameva Jayate Logo"
                  src="../assets/images/satyameva_jayate.png"
                  style="height: 75px; width: 70px"
                />
              </td>
            </tr>
          </table>

          <table style="width: 100%">
            <tr>
              <td valign="top" style="width: 90%">
                <table style="width: 100%">
                  <tr>
                    <td style="width: 35%; font-weight: bold">
                      <span>Application No</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td>
                      <span>{{ lblAppNo }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 35%; font-weight: bold">
                      <span>Post Applied For</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td>{{ lblPostTypeName }}</td>
                  </tr>
                  <tr>
                    <td style="width: 35%; font-weight: bold">Gender</td>
                    <td style="width: 3%">:</td>
                    <td>{{ lblGender }}</td>
                  </tr>
                  <tr>
                    <td style="width: 35%; font-weight: bold">
                      <span>Applied Caste / Class Type</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td>{{ lblAppCasteTypeName }}</td>
                  </tr>
                  <tr>
                    <td style="width: 35%; font-weight: bold">Category</td>
                    <td style="width: 3%">:</td>
                    <td>{{ lblMainCatName }}</td>
                  </tr>
                  <tr>
                    <td style="width: 35%; font-weight: bold">Nationality</td>
                    <td style="width: 3%">:</td>
                    <td>{{ lblNationalityName }}</td>
                  </tr>
                </table>
              </td>
              <td valign="top" style="width: 10%">
                <img id="candPhoto" alt="Candidate Photo" style="height: 120px; width: 100px" />
              </td>
            </tr>
          </table>

          <br />
          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 25px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
            "
          >
            <tr>
              <td style="padding-left: 5px"><span>Personal Details</span></td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="PersonnalDetails"
          >
            <tr>
              <td
                colspan="2"
                style="width: 100%; border-bottom: solid 1px black"
              >
                <table style="width: 100%; padding-left: 4px">
                  <tr>
                    <td style="width: 20%; font-weight: bold">Name</td>
                    <td style="width: 3%">:</td>
                    <td style="width: 77%">
                      <span>{{ lblCandName }}</span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="width: 50%" valign="top">
                <table style="width: 100%">
                  <tr>
                    <td style="width: 41%; font-weight: bold">
                      <span>Father's Full Name</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">
                      <span>{{ lblFatherName }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold">DOB</td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblDOB }}</td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold">
                      Phone No (STD Code)
                    </td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblCandPhone }}</td>
                  </tr>
                  <!-- <tr>
                    <td style="width: 41%; font-weight: bold">Email</td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblEmailID }}</td>
                  </tr> -->
                  <tr>
                    <td style="width: 41%; font-weight: bold">
                      <span>Marital Status</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblMStatusName }}</td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold">
                      <span>Domicile State</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblDomicileStateName }}</td>
                  </tr>
                  <tr v-if="isJKDomicile">
                    <td style="width: 41%; font-weight: bold">
                      <span>Domicile To</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblDomicileTo }}</td>
                  </tr>

                  <tr v-if="isPH">
                    <td style="width: 41%; font-weight: bold">Percentage</td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblPHPercentage }}</td>
                  </tr>
                </table>
              </td>
              <td style="width: 50%" valign="top">
                <table style="width: 100%">
                  <tr>
                    <td style="width: 41%; font-weight: bold">
                      <span>Mother's Name</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblMotherName }}</td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold">Religion</td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblReligionName }}</td>
                  </tr>
                  <!-- <tr>
                    <td style="width: 41%; font-weight: bold">Mobile No</td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblCandMobile }}</td>
                  </tr> -->
                  <!-- <tr>
                    <td style="width: 41%; font-weight: bold">Aadhaar No</td>
                    <td style="width: 4%">:</td>
                    <td style="width: 56%">{{ lblAadharNo }}</td>
                  </tr> -->
                  <tr>
                    <td style="width: 41%; font-weight: bold">
                      <span>Identification Mark</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">
                      <span>{{ lblIDMark }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold">
                      <span>Caste Type</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblCasteTypeName }}</td>
                  </tr>
                  <tr v-if="isJKDomicile">
                    <td style="width: 41%; font-weight: bold">
                      <span>Domicile From</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">
                      <span>{{ lblDomicileFrom }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold">Sub Caste</td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblCaste }}</td>
                  </tr>
                  <tr v-if="isPH">
                    <td style="width: 41%; font-weight: bold">
                      <span>Physically Handicapped</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">
                      <span>{{ lblIsPH }}</span>
                    </td>
                  </tr>
                  <tr v-if="isPH">
                    <td style="width: 41%; font-weight: bold">
                      <span>Requirement of Scribe</span>
                    </td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblIsReqForScribe }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 25px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
              margin-top: 15px;
            "
          >
            <tr>
              <td style="padding-left: 5px">Address Details</td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="AddressDetails"
          >
            <tr>
              <td style="width: 50%" valign="top">
                <table style="width: 100%">
                  <tr>
                    <td style="width: 41%; font-weight: bold" valign="top">
                      <span>Correspondence Address</span>
                    </td>
                    <td style="width: 3%" valign="top">:</td>
                    <td style="width: 56%" valign="top">
                      <span>{{ lblPostalAddress }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold" valign="top">
                      State
                    </td>
                    <td style="width: 3%" valign="top">:</td>
                    <td style="width: 56%" valign="top">
                      <span>{{ lblPostalStateName }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold" valign="top">
                      District
                    </td>
                    <td style="width: 3%" valign="top">:</td>
                    <td style="width: 56%" valign="top">
                      <span>{{ lblPostalDistrictName }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold" valign="top">
                      PO
                    </td>
                    <td style="width: 3%" valign="top">:</td>
                    <td style="width: 56%" valign="top">{{ lblPostalCity }}</td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold" valign="top">
                      Pin
                    </td>
                    <td style="width: 3%" valign="top">:</td>
                    <td style="width: 56%" valign="top">{{ lblPostalPin }}</td>
                  </tr>
                </table>
              </td>
              <td style="width: 50%" valign="top">
                <table style="width: 100%">
                  <tr>
                    <td style="width: 41%; font-weight: bold" valign="top">
                      <span>Permanent Address</span>
                    </td>
                    <td style="width: 3%" valign="top">:</td>
                    <td style="width: 56%" valign="top">{{ lblPerAddress }}</td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold" valign="top">
                      State
                    </td>
                    <td style="width: 3%" valign="top">:</td>
                    <td style="width: 56%" valign="top">
                      <span>{{ lblPerStateName }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold" valign="top">
                      District
                    </td>
                    <td style="width: 3%" valign="top">:</td>
                    <td style="width: 56%" valign="top">
                      <span>{{ lblPerDistrictName }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold" valign="top">
                      PO
                    </td>
                    <td style="width: 3%" valign="top">:</td>
                    <td style="width: 56%">{{ lblPerCity }}</td>
                  </tr>
                  <tr>
                    <td style="width: 41%; font-weight: bold">Pin</td>
                    <td style="width: 3%">:</td>
                    <td style="width: 56%">{{ lblPerPin }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 25px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
              margin-top: 15px;
            "
            v-if="lstCandQualifications != null"
          >
            <tr>
              <td style="padding-left: 5px">
                <span>Educational & Additional Details</span>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="QualDetails"
            v-if="lstCandQualifications != null"
          >
            <tr>
              <td style="width: 3%" align="center">Sr. No.</td>
              <td style="width: 10%" align="center">Qualification</td>
              <td style="width: 8%" align="center">Roll No.</td>
              <td style="width: 18%" align="center">School/ College Name</td>
              <td style="width: 8%" align="center">State</td>
              <td style="width: 10%" align="center">Board/ University</td>
              <td style="width: 8%" align="center">Passing Year</td>
              <td style="width: 8%" align="center">Total Marks</td>
              <td style="width: 10%" align="center">Is Grade / CGPA / CPI</td>
              <td style="width: 10%" align="center">Marks / Grade / CGPA / CPI Obtained</td>
              <td style="width: 7%" align="center">Aggre gate %</td>
            </tr>

            <tr
              v-for="(qual, index) in lstCandQualifications.filter(
                (item, index) => {
                  // if (index == 0)
                  return item;
                }
              )"
              :key="index"
            >
              <td style="width: 3%" align="center">{{ index + 1 }}</td>
              <td style="width: 10%" align="center">{{ qual[0] }}</td>
              <td style="width: 8%" align="center">{{ qual[1] }}</td>
              <td style="width: 18%" align="center">
                {{ qual[2] }}
              </td>
              <td style="width: 8%" align="center">{{ qual[3] }}</td>
              <td style="width: 10%" align="center">
                {{ qual[4] }}
              </td>
              <td style="width: 8%" align="center">{{ qual[5] }}</td>
              <td style="width: 8%" align="center">{{ qual[8] }}</td>
              <td style="width: 10%" align="center">{{ qual[11] }}</td>
              <td style="width: 10%" align="center">
                <span v-if="qual[11] == 'Yes'"> {{ qual[6] }}</span>
                <span v-if="qual[11] == 'No'"> {{ qual[7] }}</span>
              </td>
              <td style="width: 7%" align="center">{{ qual[9] }}</td>
            </tr>
          </table>
        </div>
        <br />
        <div
          :style="[pageheighttoshow ? { height: '8.6in' } : '']"
          class="page"
          v-if="
            lstCandMisQualifications != null ||
            lstCandExperiences != null ||
            lstCandMisExperiences != null ||
            lstCandRelaxation != null ||
            lstCandSportsDetail != null ||
            lstCandCertificates != null
          "
        >
          <!-- <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 25px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
            "
            v-if="
              lstCandQualifications != null && lstCandQualifications.length > 1
            "
          >
            <tr>
              <td style="padding-left: 5px">
                Educational & Additional Details
              </td>
            </tr>
          </table> -->

          <!-- <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="QualDetails"
            v-if="
              lstCandQualifications != null && lstCandQualifications.length > 1
            "
          >
            <tr>
              <td style="width: 3%" align="center">Sr. No.</td>
              <td style="width: 10%" align="center">Qualification</td>
              <td style="width: 8%" align="center">Roll No.</td>
              <td style="width: 18%" align="center">School/ College Name</td>
              <td style="width: 8%" align="center">State</td>
              <td style="width: 10%" align="center">Board/ University</td>
              <td style="width: 8%" align="center">Passing Year</td>
              <td style="width: 8%" align="center">Total Marks</td>
              <td style="width: 10%" align="center">IsGrade</td>
              <td style="width: 10%" align="center">Marks / Grade Obtained</td>
              <td style="width: 7%" align="center">Aggre gate %</td>
            </tr>

            <tr
              v-for="(qual, index) in lstCandQualifications.filter(
                (item, index) => {
                  if (index > 0) return item;
                }
              )"
              :key="index"
            >
              <td style="width: 3%" align="center">{{ index + 2 }}</td>
              <td style="width: 10%" align="center">{{ qual[0] }}</td>
              <td style="width: 8%" align="center">{{ qual[1] }}</td>
              <td style="width: 18%" align="center">
                {{ qual[2] }}
              </td>
              <td style="width: 8%" align="center">{{ qual[3] }}</td>
              <td style="width: 10%" align="center">
                {{ qual[4] }}
              </td>
              <td style="width: 8%" align="center">{{ qual[5] }}</td>
              <td style="width: 8%" align="center">{{ qual[8] }}</td>
              <td style="width: 10%" align="center">{{ qual[11] }}</td>
              <td style="width: 10%" align="center">
                <span v-if="qual[11] == 'Yes'"> {{ qual[6] }}</span>
                <span v-if="qual[11] == 'No'"> {{ qual[7] }}</span>
              </td>
              <td style="width: 7%" align="center">{{ qual[9] }}</td>
            </tr>
          </table> -->

          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 20px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
              margin-top: 5px;
            "
            v-if="lstCandMisQualifications != null"
          >
            <tr>
              <td style="padding-left: 5px">Miscellaneous Qualification</td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="QualDetails"
            v-if="lstCandMisQualifications != null"
          >
            <tr>
              <td style="width: 15%" align="center">Qualification</td>
              <td style="width: 10%" align="center">Roll No.</td>
              <td style="width: 15%" align="center">School/College Name</td>
              <td style="width: 10%" align="center">State</td>
              <td style="width: 10%" align="center">Board / University</td>
              <td style="width: 5%" align="center">Pass ing Year</td>
              <td style="width: 5%" align="center">Total Marks</td>
              <td style="width: 5%" align="center">Is Grade / CGPA / CPI</td>
              <td style="width: 10%" align="center">Marks / Grade / CGPA / CPI Obtained</td>
              <td style="width: 5%" align="center">Aggre gate %</td>
            </tr>
            <tr v-for="(mqual, index) in lstCandMisQualifications" :key="index">
              <td style="width: 15%" align="center">{{ mqual[0] }}</td>
              <td style="width: 10%" align="center">{{ mqual[1] }}</td>
              <td style="width: 15%" align="center">{{ mqual[2] }}</td>
              <td style="width: 10%" align="center">{{ mqual[3] }}</td>
              <td style="width: 10%" align="center">{{ mqual[4] }}</td>
              <td style="width: 5%" align="center">{{ mqual[5] }}</td>
              <td style="width: 5%" align="center">{{ mqual[9] }}</td>
              <td style="width: 5%" align="center">{{ mqual[6] }}</td>
              <td style="width: 10%" align="center">
                <span v-if="mqual[6] == 'Yes'">{{ mqual[7] }}</span>
                <span v-if="mqual[6] == 'No'">{{ mqual[8] }}</span>
              </td>
              <td style="width: 5%" align="center">{{ mqual[10] }}</td>
            </tr>
          </table>

          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 20px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
              margin-top: 5px;
            "
            v-if="lstCandExperiences != null"
          >
            <tr>
              <td style="padding-left: 5px">Experience / Certificate</td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="QualDetails"
            v-if="lstCandExperiences != null"
          >
            <tr>
              <td style="width: 20%" align="center">Trade</td>
              <td style="width: 30%" align="center">Name of Institution</td>
              <td style="width: 10%" align="center">Govt/Private</td>
              <td style="width: 10%" align="center">Recognised By</td>
              <td style="width: 10%" align="center">Exp./Cert. In Years</td>
              <td style="width: 10%" align="center">Exp./Cert. In Months</td>
            </tr>
            <tr v-for="(exp, index) in lstCandExperiences" :key="index">
              <td style="width: 20%" align="center">{{ exp[0] }}</td>
              <td style="width: 10%" align="center">{{ exp[1] }}</td>
              <td style="width: 15%" align="center">{{ exp[2] }}</td>
              <td style="width: 10%" align="center">{{ exp[3] }}</td>
              <td style="width: 10%" align="center">{{ exp[4] }}</td>
              <td style="width: 5%" align="center">{{ exp[5] }}</td>
            </tr>
          </table>

          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 20px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
              margin-top: 5px;
            "
            v-if="lstCandMisExperiences != null"
          >
            <tr>
              <td style="padding-left: 5px">Miscellaneous Experience</td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="QualDetails"
            v-if="lstCandMisExperiences != null"
          >
            <tr>
              <td style="width: 20%" align="center">Trade</td>
              <td style="width: 30%" align="center">Name of Institution</td>
              <td style="width: 10%" align="center">Govt/Private</td>
              <td style="width: 10%" align="center">Recognised By</td>
              <td style="width: 10%" align="center">Experience In Years</td>
              <td style="width: 10%" align="center">Experience In Months</td>
            </tr>
            <tr v-for="(mexp, index) in lstCandMisExperiences" :key="index">
              <td style="width: 20%" align="center">{{ mexp[0] }}</td>
              <td style="width: 30%" align="center">{{ mexp[1] }}</td>
              <td style="width: 10%" align="center">{{ mexp[2] }}</td>
              <td style="width: 10%" align="center">{{ mexp[3] }}</td>
              <td style="width: 10%" align="center">{{ mexp[4] }}</td>
              <td style="width: 10%" align="center">{{ mexp[5] }}</td>
            </tr>
          </table>

          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 20px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
              margin-top: 5px;
            "
            v-if="lblMainCatName == 'ESM'"
          >
            <tr>
              <td style="padding-left: 5px">
                Ex-Serviceman
                {{
                  lstCandRelaxation == null
                    ? ""
                    : ": Relaxation" + lstCandRelaxation[0][1]
                }}
              </td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="QualDetails"
            v-if="lblMainCatName == 'ESM'"
          >
            <tr>
              <td style="width: 10%" align="center">Sr. No.</td>
              <td style="width: 20%" align="center">Service Type</td>
              <td style="width: 15%" align="center">Date of Enrolment</td>
              <td style="width: 15%" align="center">Date of Retirement</td>
              <td style="width: 25%" align="center">Total Service Rendered</td>
              <td style="width: 15%" align="center">Dis. Book / Order / NOC No.</td>
            </tr>
            <tr v-for="(relx, index) in lstCandRelaxtionDetail" :key="index">
              <td style="width: 10%" align="center">{{ relx[0] }}</td>
              <td style="width: 20%" align="center">{{ relx[1] }}</td>
              <td style="width: 15%" align="center">{{ relx[3] }}</td>
              <td style="width: 15%" align="center">{{ relx[4] }}</td>
              <td style="width: 25%" align="center">
                {{ relx[5] }}Year {{ relx[6] }}Month {{ relx[7] }}Day
              </td>
              <td style="width: 15%" align="center">{{ relx[8] }}</td>
            </tr>
          </table>

          <table
            style="
              border: solid 1px black;
              height: 25px;
              width: 100%;
              background-color: #f3f1f1;
              margin-top: 5px;
            "
          >
            <tr>
              <td style="width: 50%">
                <span style="font-weight: bold">Recruitment Type :</span>
                {{ lblRecruitmentTypeName }}
              </td>

              <td style="width: 50%">
                <span style="font-weight: bold">Departmental/Government :</span>
                {{ lblRelaxationTypeName }}
              </td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="QualDetails"
            v-if="lblRecruitmentTypeID == 3 || lblRecruitmentTypeID == 5"
          >
            <tr>
              <td style="width: 10%" align="center">Date of Appointment</td>
              <td style="width: 10%" align="center">Worked Till Present</td>
              <td style="width: 10%" align="center">Retirement Date</td>
              <td style="width: 10%" align="center">Name Of Organization</td>
              <td style="width: 10%" align="center">Name Of Post</td>
              <td style="width: 25%" align="center">Office Address</td>
              <td style="width: 5%" align="center">NOC Obtained</td>
              <td
                style="width: 10%"
                align="center"
                v-if="lblNocObtained != 'No'"
              >
                Letter No
              </td>
              <td
                style="width: 10%"
                align="center"
                v-if="lblNocObtained != 'No'"
              >
                Letter Date
              </td>
            </tr>
            <tr>
              <td style="width: 10%" align="center">{{ lblDateOfApp }}</td>
              <td style="width: 10%" align="center">
                {{ lblIsWorkTillPresent }}
              </td>
              <td style="width: 5%" align="center">
                {{ lblRetirementDate }}
              </td>
              <td style="width: 10%" align="center">{{ lblOrgName }}</td>
              <td style="width: 10%" align="center">{{ lblPostName }}</td>
              <td style="width: 25%" align="center">{{ lblOfficeAddress }}</td>
              <td style="width: 5%" align="center">{{ lblNocObtained }}</td>
              <td
                style="width: 10%"
                align="center"
                v-if="lblNocObtained != 'No'"
              >
                {{ lblLetterNo }}
              </td>
              <td
                style="width: 10%"
                align="center"
                v-if="lblNocObtained != 'No'"
              >
                {{ lblLetterDate }}
              </td>
            </tr>
          </table>

          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 20px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
              margin-top: 5px;
            "
            v-if="lstCandSportsDetail != null"
          >
            <tr>
              <td style="padding-left: 5px">Sports Man Details</td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="QualDetails"
            v-if="lstCandSportsDetail != null"
          >
            <tr>
              <td style="width: 5%" align="center">Sr. No.</td>
              <td style="width: 20%" align="center">Level</td>
              <td style="width: 10%" align="center">Medal</td>
              <td style="width: 10%" align="center">Sports Discipline</td>
              <td style="width: 20%" align="center">Competition Name</td>
              <td style="width: 15%" align="center">Country</td>
              <td style="width: 15%" align="center">State</td>
              <td style="width: 5%" align="center">Year</td>
              <td style="width: 10%" align="center">Clearance No.</td>
              <td style="width: 10%" align="center">Clearance Date</td>
            </tr>
            <tr v-for="(sport, index) in lstCandSportsDetail" :key="index">
              <td style="width: 5%" align="center">{{ sport[0] }}</td>
              <td style="width: 20%" align="center">{{ sport[1] }}</td>
              <td style="width: 10%" align="center">{{ sport[3] }}</td>
              <td style="width: 10%" align="center">{{ sport[2] }}</td>
              <td style="width: 20%" align="center">{{ sport[4] }}</td>
              <td style="width: 15%" align="center">{{ sport[6] }}</td>
              <td style="width: 15%" align="center">{{ sport[5] }}</td>
              <td style="width: 5%" align="center">{{ sport[7] }}</td>
              <td style="width: 10%" align="center">{{ sport[8] }}</td>
              <td style="width: 10%" align="center">{{ sport[9] }}</td>
            </tr>
          </table>

          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 20px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
              margin-top: 5px;
            "
            v-if="lstCandCertificates != null"
          >
            <tr>
              <td style="padding-left: 5px">Certificates</td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="QualDetails"
            v-if="lstCandCertificates != null"
          >
            <tr>
              <td style="width: 5%" align="center">Sr. No.</td>
              <td style="width: 20%" align="center">
                Document / Certificate Name
              </td>
              <td style="width: 10%" align="center">
                Document / Certificate No.
              </td>
              <td style="width: 10%" align="center">Issue Date</td>
              <td style="width: 20%" align="center">Authority Name</td>
              <td style="width: 15%" align="center">State</td>
              <td style="width: 15%" align="center">District</td>
              <td style="width: 5%" align="center">Life Time Valid</td>
              <td style="width: 10%" align="center">Valid Up To</td>
            </tr>
            <tr v-for="(certf, index) in lstCandCertificates" :key="index">
              <td style="width: 5%" align="center">{{ certf[0] }}</td>
              <td style="width: 20%" align="center">{{ certf[1] }}</td>
              <td style="width: 10%" align="center">{{ certf[2] }}</td>
              <td style="width: 10%" align="center">{{ certf[3] }}</td>
              <td style="width: 20%" align="center">{{ certf[4] }}</td>
              <td style="width: 15%" align="center">{{ certf[6] }}</td>
              <td style="width: 15%" align="center">{{ certf[5] }}</td>
              <td style="width: 5%" align="center">{{ certf[7] }}</td>
              <td style="width: 10%" align="center">
                <span v-if="certf[7] == 'No'">{{ certf[8] }}</span>
              </td>
            </tr>
          </table>
        </div>
        <div
          :style="[pageheighttoshow ? { height: '8.0in' } : '']"
          class="page"
        >
          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 25px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
              margin-top: 15px;
            "
            v-if="lblIsRegInEmplExch == 'Yes'"
          >
            <tr>
              <td style="padding-left: 5px">Employment Exchange</td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="QualDetails"
            v-if="lblIsRegInEmplExch == 'Yes'"
          >
            <tr>
              <td style="width: 10%" align="center">Reg. No.</td>
              <td style="width: 10%" align="center">Reg. Date</td>
              <td style="width: 20%" align="center">Exchange Name</td>
              <td style="width: 15%" align="center">Exchange State</td>
              <td style="width: 15%" align="center">Exchange District</td>
              <td style="width: 30%" align="center">Exchange Address</td>
            </tr>
            <tr>
              <td style="width: 10%" align="center">{{ lblEmplExchRegNo }}</td>
              <td style="width: 10%" align="center">
                {{ lblEmplExchRegDate }}
              </td>
              <td style="width: 20%" align="center">
                {{ lblEmplExchRegName }}
              </td>
              <td style="width: 15%" align="center">
                {{ lblEmplExchRegState }}
              </td>
              <td style="width: 15%" align="center">
                {{ lblEmplExchRegDistrict }}
              </td>
              <td style="width: 30%" align="center">
                {{ lblEmplExchRegAddress }}
              </td>
            </tr>
          </table>

          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 25px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
              margin-top: 5px;
            "
          >
            <tr>
              <td style="padding-left: 5px">Uploaded Documents</td>
            </tr>
          </table>

          <table
            style="width: 100%; border: solid 1px black; font-size: 8pt"
            class="QualDetails"
          >
            <tr>
              <td style="width: 10%" align="center">Sr. No.</td>
              <td style="width: 20%" align="center">Document Type</td>
              <td style="width: 20%" align="center">Document No</td>
              <td style="width: 50%" align="center">Document Name</td>
            </tr>
            <tr v-for="(docs, index) in lstCandDocuments" :key="index">
              <td style="width: 10%" align="center">{{ index + 1 }}.</td>
              <td style="width: 20%" align="center">{{ docs[0] }}</td>
              <td style="width: 20%" align="center">{{ docs[1] }}</td>
              <td style="width: 50%" align="center">{{ docs[2] }}</td>
            </tr>
          </table>

          <br />
          <table style="width: 100%" class="">
            <tr>
              <td
                style="padding-right: 10px; width: 50%"
                align="center"
                valign="top"
              >
                <table
                  style="
                    border: solid 1px black;
                    border-bottom: none;
                    height: 25px;
                    width: 100%;
                    font-weight: bold;
                    background-color: #f3f1f1;
                  "
                >
                  <tr>
                    <td style="padding-left: 5px">Exam City Choice</td>
                  </tr>
                </table>

                <table
                  style="width: 100%; border: solid 1px black; font-size: 8pt"
                  class="QualDetails"
                >
                  <tr>
                    <td style="width: 15%" align="center">Sr. No.</td>
                    <td style="width: 85%" align="center">Exam City</td>
                  </tr>
                  <tr v-for="(city, index) in lstCandExamCentre" :key="index">
                    <td style="width: 15%" align="center">{{ city[0] }}</td>
                    <td style="width: 85%" align="center">{{ city[1] }}</td>
                  </tr>
                </table>
              </td>
              <td
                style="padding-left: 10px; width: 50%"
                align="center"
                valign="top"
              >
                <table
                  style="
                    border: solid 1px black;
                    border-bottom: none;
                    height: 25px;
                    width: 100%;
                    font-weight: bold;
                    background-color: #f3f1f1;
                  "
                >
                  <tr>
                    <td style="padding-left: 5px">
                      Preferred Location for Employment
                    </td>
                  </tr>
                </table>

                <table
                  style="width: 100%; border: solid 1px black; font-size: 8pt"
                  class="QualDetails"
                >
                  <tr>
                    <td style="width: 15%" align="center">Sr. No.</td>
                    <td style="width: 85%" align="center">Posting Region</td>
                  </tr>
                  <tr
                    v-for="(region, index) in lstCandPostingRegion"
                    :key="index"
                  >
                    <td style="width: 15%" align="center">{{ region[0] }}</td>
                    <td style="width: 85%" align="center">{{ region[1] }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <br />
          <table
            style="
              border: solid 1px black;
              border-bottom: none;
              height: 25px;
              width: 100%;
              font-weight: bold;
              background-color: #f3f1f1;
            "
          >
            <tr>
              <td style="padding-left: 5px">Declaration</td>
            </tr>
          </table>

          <div style="border: solid 1px black">
            <ul style="margin-left: 20px">
              <li>
                I hereby confirm that I have read the “Instructions to fill
                online application” provided in documents in
                https://aocrecruitment.gov.in
              </li>
              <br />
              <li>
                I accept all the terms and conditions given in the “Instructions
                to fill online application” provided in documents in
                https://aocrecruitment.gov.in
              </li>
              <br />
            </ul>
            <br />
          </div>
          <br />
          <table style="width: 100%">
            <tr>
              <td style="width: 10%" align="center">Place:</td>
              <td style="width: 40%" align="left">
                {{ lblPlace }}
              </td>
              <td style="width: 10%" align="center">Date:</td>
              <td style="width: 40%" align="left">
                {{ lblDate }}
              </td>
            </tr>
          </table>

          <div style="float: right; margin-right: 50px">
            <img id="imgSign" alt="Candidate Signature" style="height: 75px; width: 150px" />
          </div>
        </div>
      </div>
    </div>
    <input type="button" value="Print" v-on:click="printpdf()" v-if="false" />
    <img  src="" alt="" id="imgtest1" />
  </div>
</template>
<style scoped>
table {
  border-collapse: collapse;
}
td {
  padding-bottom: 3px;
}
.CandInfo .Flex_Cell {
  border: solid 1px black;
  font-size: 8pt;
}
.PersonnalDetails td,
.AddressDetails td {
  padding-left: 2px;
  padding-top: 2px;
}
.QualDetails {
  table-layout: fixed;
}
.QualDetails tr:first-child td {
  font-weight: bold;
}
.QualDetails td {
  border-top: 0.01em solid darkgray;
  border-right: 0.01em solid darkgray;
  word-wrap: break-word;
  letter-spacing: 0.5px;
}
@media print {
  body * {
    visibility: hidden;
  }
  #dvApplicationPrint * {
    visibility: visible;
  }
  #dvApplicationPrint {
    position: absolute;
    top: 40px;
    left: 30px;
  }
}
.page {
  padding: 8px;
  margin: 8px;
  /* border: solid 2px black; */
}
span {
  letter-spacing: 0.5px;
}
</style>
<script>
import "jspdf/dist/polyfills.es.js";
import { jsPDF } from "jspdf";
import axios from "axios";
import config from "@/router/globalConfig";

export default {
  name: "ApplicationPrint",
  props: {
    candidateID: { type: String, required: true },
    eventBus: { type: Object },
    eventMount: { type: Object },
  },
  data() {
    return {
      lblAppNo: "",
      lblPostTypeName: "",
      lblGender: "",
      lblAdvtNo: "",
      lblAppCasteTypeName: "",
      lblMainCatName: "",
      lblNationalityName: "",
      lblCandName: "",
      lblFatherName: "",
      lblMotherName: "",
      lblDOB: "",
      lblReligionName: "",
      lblCandPhone: "",
      lblCandMobile: "",
      lblEmailID: "",
      lblAadharNo: "",
      lblMStatusName: "",
      lblIDMark: "",
      lblDomicileStateName: "",
      lblPostalAddress: "",
      lblPostalStateName: "",
      lblPostalDistrictName: "",
      lblPostalCity: "",
      lblPostalPin: "",
      lblPerAddress: "",
      lblPerStateName: "",
      lblPerDistrictName: "",
      lblPerCity: "",
      lblPerPin: "",
      isPH: false,
      isJKDomicile: false,
      lblDomicileFrom: "",
      lblDomicileTo: "",
      lblCasteTypeName: "",
      lblCaste: "",
      lblPHPercentage: "",
      lblIsReqForScribe: "",
      lblIsPH: "",
      lblDateOfApp: "",
      lblOrgName: "",
      lblPostName: "",
      lblOfficeAddress: "",
      lblNocObtained: "",
      lblLetterNo: "",
      lblLetterDate: "",
      lblIsRegInEmplExch: "",
      lblEmplExchRegNo: "",
      lblEmplExchRegDate: "",
      lblEmplExchRegName: "",
      lblEmplExchRegState: "",
      lblEmplExchRegDistrict: "",
      lblEmplExchRegAddress: "",
      lblPlace: "",
      lblDate: "",
      lblIsWorkTillPresent: "",
      lblRetirementDate: "",

      lstCandQualifications: null,
      lstCandMisQualifications: null,
      lstCandExperiences: null,
      lstCandMisExperiences: null,
      lstCandRelaxation: null,
      lstCandRelaxtionDetail: null,
      lstCandSportsDetail: null,
      lstCandCertificates: null,
      lstCandExamCentre: null,
      lstCandPostingRegion: null,
      lstCandDocuments: null,
      lstCandReject: null,
      lblrecruitmentTypeName: null,
      lblrelaxationTypeName: null,
      lblRecruitmentTypeID: null,
      lblRelaxationTypeID: null,
      dgwatermk:"",
      waterMarkText:"",
      waterMarkImage:"",
      
      // lblApplNo: "",
      // lblPostAppliedFor: "",
      // lblApplyCategory: "",
      // lblReligion: "",
      // lblCaste: "",
      // lblDomicile: "",
      // lblSex: "",
      // lblMarital: "",
      // lblDOB: "",
      // lblTitle: "",
      // lblCandidateName: "",
      // lblFathersName: "",
      // lblCAddress: "",
      // lblMob: "",
      // lblEmail: "",
      // lblAadharNo: "",
      // isExServiceMan: false,
      // lblIsExSerMan: "",
      // lblExServicemanType: "",
      // lblDateofDischarge: "",
      // lblServiceYr: "",
      // lblIsPH: "",
      // lblPHType: "",
      // lblPHPercent: "",
      // lblIsSportMan: "",
      // lblSportLevel: "",
      // lblLabel3: "",
      // isAppMedia: false,
      // lblAppMedia: "",
      // lblorg: "",
      // lblorgpost: "",
      // lblduration: "",
      // lblDOA: "",
      // lblNOC: "",
      // lblExamLocation: "",
      // lblPreferrredLocation: "",
      // lblPlace: "",
      // lblApplDate: "",
      // lblCurrentDate: "",
      // lstCandQualifications: null,
      // lstCandExperiences: null
    };
  },
  methods: {
    getCandidateDetail() {
      axios
        .get(config.WEB_API_PATH + "Report/GetAppPreview", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: { candidateID: this.candidateID, type: 1 },
          crossdomain: true,
        })
        .then(
          (response) => {
            this.setCandDetails(response.data.result.candDetails[0]);
            this.lstCandQualifications =
              response.data.result.candQualifications;
            this.lstCandMisQualifications =
              response.data.result.candMisQualifications;
            this.lstCandExperiences = response.data.result.candExperiences;
            this.lstCandMisExperiences =
              response.data.result.candMisExperiences;
            this.lstCandRelaxation = response.data.result.candRelaxtion;
            this.lstCandRelaxtionDetail =
              response.data.result.candRelaxtionDetail;
            this.lstCandSportsDetail = response.data.result.candSportsDetail;
            this.lstCandCertificates = response.data.result.candCertificates;
            this.lstCandExamCentre = response.data.result.candExamCentre;
            this.lstCandPostingRegion = response.data.result.candPostingRegion;
            this.lstCandDocuments = response.data.result.candDocuments;
            this.lstCandReject = response.data.result.candReject;

            this.waterMarkText = this.lblCandName + '-' + this.lblAppNo + '-' + response.data.result4;
            this.waterMarkImage = response.data.result5;
            
            
          },
          (error) => {
            alert("error : " + error.response);
          },
          (failure) => {
            alert("failure : " + failure.response);
          }
        );
    },

    setCandDetails(data) {
      this.lblAppNo = data[0];
      this.lblAdvtNo = data[1];
      this.lblPostTypeName = data[2];
      this.lblMainCatName = data[3];
      this.lblAppCasteTypeName = data[4];
      this.lblNationalityName = data[5];
      this.lblCandName =
        data[6] + " " + data[7] + " " + data[8] + " " + data[9];
      this.lblGender = data[10];
      this.lblDOB = data[11];
      this.lblMStatusName = data[12];
      this.lblFatherName = data[13];
      this.lblMotherName = data[14];
      this.lblEmailID = data[15];
      this.lblCandPhone = data[16];
      this.lblCandMobile = data[17];
      this.lblReligionName = data[18];
      this.lblCasteTypeName = data[19];
      this.lblCaste = data[20];
      this.lblAadharNo = data[21];
      this.lblDomicileStateName = data[22];
      this.isJKDomicile = data[23] != "" ? true : false;
      this.lblDomicileFrom = data[23];
      this.lblDomicileTo = data[24];
      this.lblIDMark = data[25];
      this.lblPHPercentage = data[26];
      this.lblIsReqForScribe = data[27];
      this.lblPostalAddress = data[28];
      this.lblPostalPin = data[29];
      this.lblPostalCity = data[30];
      this.lblPostalDistrictName = data[31];
      this.lblPostalStateName = data[32];
      this.lblPerAddress = data[34];
      this.lblPerPin = data[35];
      this.lblPerCity = data[36];
      this.lblPerDistrictName = data[37];
      this.lblPerStateName = data[38];
      let candPhoto = document.getElementById("candPhoto");
      candPhoto.src = "data:image/jpg; base64," + data[56];
      let candSign = document.getElementById("imgSign");
      candSign.src = "data:image/jpg; base64," + data[57];
      this.isPH = data[60] == "11" ? true : false;
      this.lblIsPH = this.lblPHPercentage == "" ? "No" : "Yes";
      this.lblDateOfApp = data[43];
      this.lblOrgName = data[40];
      this.lblPostName = data[42];
      this.lblOfficeAddress = data[41];
      this.lblNocObtained = data[44];
      this.lblLetterNo = data[45];
      this.lblLetterDate = data[46];

      this.lblIsRegInEmplExch = data[47];
      this.lblEmplExchRegNo = data[48];
      this.lblEmplExchRegDate = data[49];
      this.lblEmplExchRegName = data[50];
      this.lblEmplExchRegState = data[53];
      this.lblEmplExchRegDistrict = data[52];
      this.lblEmplExchRegAddress = data[51];
      this.lblPlace = data[54];
      this.lblDate = data[55];

      this.lblIsWorkTillPresent = data[63];
      //if(this.lblIsWorkTillPresent='Till Present')
      //{
      this.lblRetirementDate = data[64];

      this.lblRecruitmentTypeID = data[65];
      this.lblRecruitmentTypeName = data[66];
      this.lblRelaxationTypeID = data[67];
      this.lblRelaxationTypeName = data[68];

      this.dgwatermk = document.getElementById("imgWatMark").src;// "../assets/images/WaterMarkClient.png"; //"/static/img/AOC_Logo.6742857.png";
      
      //}
      // this.lblApplNo = data[1];
      //
      // this.lblApplyCategory = data[3];
      // this.lblReligion = data[15];
      // this.lblCaste = data[16];
      // this.lblDomicile = data[24];
      // this.lblSex = data[7];
      // this.lblMarital = data[9];
      // this.lblDOB = data[8];
      // this.lblCandidateName = data[4] + " " + data[5] + " " + data[6];
      // this.lblTitle = data[49];
      // this.lblFathersName = data[10];
      // if (data[34] == data[35] && data[34] == "")
      //   this.lblCAddress =
      //     data[32] +
      //     ", " +
      //     data[35] +
      //     ", PIN - " +
      //     data[33] +
      //     " (" +
      //     data[36] +
      //     ")";
      // else if (data[35] == "")
      //   this.lblCAddress =
      //     data[32] +
      //     ", " +
      //     data[34] +
      //     ", PIN - " +
      //     data[33] +
      //     " (" +
      //     data[36] +
      //     ")";
      // else if (data[34] != data[35] && data[34] != "" && data[35] != "")
      //   this.lblCAddress =
      //     data[32] +
      //     ", " +
      //     data[34] +
      //     ", " +
      //     data[35] +
      //     ", PIN - " +
      //     data[33] +
      //     " (" +
      //     data[36] +
      //     ")";
      // this.lblMob = data[14];
      // this.lblEmail = data[12];
      // this.lblAadharNo = data[17];
      // this.lblIsExSerMan = data[18];
      // if (data[51] == "12") {
      //   this.isExServiceMan = true;
      //   this.lblIsExSerMan = data[18] + " - " + data[55];
      //   if (data[21] != 0 || data[22] != 0 || data[23] != 0)
      //     this.lblServiceYr =
      //       data[21] + " Years, " + data[22] + " Months, " + data[23] + " Days";
      //   else this.lblServiceYr = "--Not Filled--";
      // } else {
      //   if (data[55] != "") {
      //     this.lblIsExSerMan = data[18] + " - " + data[55];
      //   }
      // }

      // this.lblIsSportMan = data[30];
      // this.lblPreferrredLocation = data[46];
      // this.lblExamLocation = data[45];
      // this.lblPlace = data[47];
      // this.lblApplDate = data[48];
      // this.lblCurrentDate = data[50];
      // this.lblExServicemanType = data[20];
      // this.lblDateofDischarge = data[40];
      // this.lblIsPH = data[27];
      // if (data[51] == "11") {
      //   this.lblPHType = " / " + data[28];
      //   this.lblPHPercent = " / " + data[29];
      // } else {
      //   this.lblPHType = "";
      //   this.lblPHPercent = "";
      // }
      // this.lblSportLevel = data[31];
      // this.lblAppMedia = data[37];
      // if (data[53] == "3" || data[53] == "5") {
      //   this.isAppMedia = true;
      //   this.lblorg = data[42];
      //   this.lblorgpost = data[43];
      //   this.lblduration = data[44];
      //   this.lblDOA = data[41];
      //   this.lblNOC = data[39];
      // } else if (data[53] == "2" || data[53] == "4") {
      //   this.lblAppMedia = data[37] + " , Reg. No " + data[56];
      // }
    },    
    printpdf() {
      //var printContents = document.getElementById("dvApplicationPrint").innerHTML;
      //var originalContents = document.body.innerHTML;

      //document.body.innerHTML = printContents;

      //window.print();

      //document.body.innerHTML = originalContents;

      let me = this;
      let source =
      window.document.getElementById("dvApplicationPrint").innerHTML;
      let doc = new jsPDF("p", "pt", "a4");
            
      // document.getElementById("imgtest1").src()
      //let doc = new jsPDF("p", "pt", [612,792]);
      var watText = this.waterMarkText;
      var watImg = this.waterMarkImage;           
     
      doc.html(source, {
        callback: function (pdf) {
          
          var totalPages = doc.internal.getNumberOfPages();          

          for (var i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setTextColor(218, 220, 224);
            
            // doc.text(watText, 50,300, { angle: 35, });
            // doc.text(watText, 50,400, { angle: 35, });
            // doc.text(watText, 50, doc.internal.pageSize.height - 200, { angle: 35, });
            // doc.text(watText, 50, doc.internal.pageSize.height - 100, { angle: 35, });  

            var min = 4;
            var max = 6;            
            var numberOfWaterMark = Math.floor(Math.random() * (max - min + 1) + min);
            var incrementedNumber = 250 + numberOfWaterMark;

            doc.text(watText, 50, incrementedNumber, { angle: 35, });
            
            min = 50; max=100;
            incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
            doc.text(watText, 50, incrementedNumber, { angle: 25, });

            min = 100; max=150;
            incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
            doc.text(watText, 50, incrementedNumber, { angle: 15, });

            min = 150; max=250;
            incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
            doc.text(watText, 50, incrementedNumber, { angle: 35, });
            
             min = 250; max=350;
            incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
            doc.text(watText, 50, incrementedNumber, { angle: 35, });

            if (numberOfWaterMark > 4)
            {
              min = 300; max=350
              incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
              doc.text(watText, 50, incrementedNumber, { angle: 30, });              
            }
            if (numberOfWaterMark > 5)
            {
              min = 400; max=450;
              incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
              doc.text(watText, 50, incrementedNumber, { angle: 20, });   
            }
           
            doc.text(watText, 50, doc.internal.pageSize.height - 100, { angle: 35, });  

           //doc.addImage(watImg, 'PNG', 0, pdf.internal.pageSize.width/2, 600, 150);
           doc.addImage(watImg, 'PNG', 0, 0, 600, 842);
          }
          
          pdf.save(me.lblAppNo + "_Application.pdf");
        },
      });
    },
  },
  computed: {
    pageheighttoshow: function () {
      var isShow = false;
      var A = 0;
      var B = 0;
      var C = 0;
      var D = 0;
      var E = 0;
      var F = 0;

      A =
        this.lstCandMisQualifications != null
          ? this.lstCandMisQualifications.length
          : A;
      B = this.lstCandExperiences != null ? this.lstCandExperiences.length : B;
      C =
        this.lstCandMisExperiences != null
          ? this.lstCandMisExperiences.length
          : C;
      D =
        this.lstCandRelaxtionDetail != null
          ? this.lstCandRelaxtionDetail.length
          : D;
      E =
        this.lstCandSportsDetail != null ? this.lstCandSportsDetail.length : E;
      F =
        this.lstCandCertificates != null ? this.lstCandCertificates.length : F;

      if (A > 0 && B > 0 && C > 0) {
        isShow = true;
      } // 1
      else if (A > 0 && C > 0 && D > 0) {
        isShow = true;
      } // 2
      else if (A > 0 && D > 0 && E > 0) {
        isShow = true;
      } // 3
      else if (A > 0 && E > 0 && F > 0) {
        isShow = true;
      } // 4
      else if (A > 0 && F > 0 && B > 0) {
        isShow = true;
      } // 5
      else if (A > 0 && B > 0 && D > 0) {
        isShow = true;
      } // 6
      else if (A > 0 && B > 0 && E > 0) {
        isShow = true;
      } // 7
      else if (A > 0 && C > 0 && E > 0) {
        isShow = true;
      } // 8
      else if (A > 0 && C > 0 && F > 0) {
        isShow = true;
      } // 9
      else if (A > 0 && D > 0 && F > 0) {
        isShow = true;
      } // 10
      else if (B > 0 && C > 0 && D > 0) {
        isShow = true;
      } // 11
      else if (B > 0 && D > 0 && E > 0) {
        isShow = true;
      } // 12
      else if (B > 0 && E > 0 && F > 0) {
        isShow = true;
      } // 13
      else if (B > 0 && C > 0 && E > 0) {
        isShow = true;
      } // 14
      else if (B > 0 && C > 0 && F > 0) {
        isShow = true;
      } // 15
      else if (B > 0 && D > 0 && F > 0) {
        isShow = true;
      } // 16
      else if (C > 0 && D > 0 && E > 0) {
        isShow = true;
      } // 17
      else if (C > 0 && E > 0 && F > 0) {
        isShow = true;
      } // 18
      else if (C > 0 && D > 0 && F > 0) {
        isShow = true;
      } // 19
      else if (D > 0 && E > 0 && F > 0) {
        isShow = true;
      } // 20
      else {
        isShow = false;
      }      

      return isShow;
    },
  },
  mounted() {
    if (this.eventBus) {
      let _printPDF = this.printpdf;
      let _getCandidateDetail = this.getCandidateDetail;
      this.eventBus.$on("printPDF", function () {
        _printPDF();
      });
      this.eventBus.$on("getCandidateDetail", function () {
        _getCandidateDetail();
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ApplicationPrint.vue